import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import DetailsList from '../../../../../../common/details-list';
import locales from '../../../../../../../constants/locales';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationSuccess } from './interfaces';

interface Props {
  operation: OperationSuccess;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, amount, cost } = operation;

  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            { label: locales.operation.label.customerMsisdn, value: operation.customer_msisdn },
            { label: locales.operation.label.customerEmail, value: details.customerEmail },
            { label: locales.operation.label.merchantCode, value: operation.merchantCode },
            { label: locales.operation.label.transactionId, value: details.transactionId },
            { label: locales.operation.label.amount, value: formatToAmount(amount.value) },
            { label: locales.operation.label.reference, value: details.reference },
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) }
          ]}
        />
      }
    />
  );
};

export default SuccessOperation;
